<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-calendar-check</v-icon>
            Aprovar Ata
          </div>
        </v-toolbar>
        <div class="container dialog pa-5">
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <div class="alert-message d-flex align-center mt-4">
                  <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
                  <span>Atenção!<br />
                          Ao aprovar a Ata, você confirma todas as informações registradas pelo formador
                          <strong>{{ content.solicitante }}</strong> sobre a Formação <strong>{{ content.nome }}</strong>.
                  </span>
                </div>
              </v-col>
            </v-row>
            <v-row class="d-flex align-center">
              <v-col cols="5">
                <span>Quantidade de participantes presentes*:</span>
              </v-col>
              <v-col cols="2">
                <v-text-field
                    v-model="content.participantesPresentes"
                    outlined
                    dense
                    hide-details
                    readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <v-data-table
              class="mt-5"
              :headers="headers"
              :items="content.anexos"
              :items-per-page="10"
              :footer-props="$footerProps"
          >
          <template v-slot:[`item.tamanho`]="{ item }">
              {{ getFileSize(item.tamanho) }}
            </template>
            <template v-slot:[`item.acoes`]="{ item }">
              <sigfoco-tooltip
                  small
                  text="Realizar Download"
                  icon="mdi-arrow-down"
                  @click="baixarArquivo(item)"
              ></sigfoco-tooltip>
            </template>
          </v-data-table>
        </div>
        <v-col cols="12" class="d-flex justify-center">
          <v-btn
              class="ma-2"
              color="primary"
              @click="confirmarAta(true)"
          >Aprovar Ata</v-btn>
          <v-btn
              class="ma-2"
              color="primary"
              @click="confirmarAta(false)"
          >Reprovar Ata</v-btn>
          <v-btn
              class="ma-2"
              color="primary"
              outlined
              @click="fecharDialog"
          >Cancelar</v-btn>
        </v-col>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from "~/commons/classes/dialog-props";
import { Ata } from "~/commons/classes/ata";
import AtaService from "~/services/manter-ata.service";
import DownloadService from "~/services/download.service";

export default {
  props: new DialogProps(Ata),
  mixins: [AtaService, DownloadService],
  data: () => ({
    headers: [
      { text: "Nome do Arquivo", align: "center", value: "nome" },
      { text: "Tipo", align: "center", value: "tipo" },
      { text: "Tamanho", align: "center", value: "tamanho" },
      { text: "Ações", align: "center", value: "acoes", sortable: false },
    ],
  }),
  methods: {
    async confirmarAta(aprovar) {
      await this.swalConfirmacao()

      let response;
      if (aprovar) {
        response = await this.$aprovarAta(this.content.id)
      } else {
        response = await this.$reprovarAta(this.content.id)
      }
      this.$notifySuccess(response.data.mensagem)

      this.fecharDialog()
    },
    fecharDialog() {
      this.$emit('onClose')
    },
    swalConfirmacao() {
      return this.$swal({
        text: `Deseja confirmar essa operação?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      })
    },
    async baixarArquivo(anexo) {
      const { data } = await this.$downloadArquivoPorId(anexo.id, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = anexo.nome || "download";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    getFileType(fileName) {
      return fileName.split(".").pop().toLowerCase();
    },
    getFileSize(bytes) {
      if (bytes >= 1024 * 1024) {
        return (bytes / (1024 * 1024)).toFixed(2) + " MB";
      } else {
        return (bytes / 1024).toFixed(2) + " KB";
      }
    },
  },
};
</script>
<style scoped>
.alert-message {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}
</style>